module.exports = __webpack_public_path__ + "img/maze_oval_c.824706fc.svg";